import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-caret-forward-sharp",
  "use": "icon-caret-forward-sharp-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" class=\"ionicon\" viewBox=\"0 0 512 512\" id=\"icon-caret-forward-sharp\"><title>Caret Forward</title><path d=\"M144 448l224-192L144 64v384z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol